import React from "react";
import Navbar from "../../components/modules/Navbar";
import "./tarifStyles.css";
import { useState } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import SwitchButton from "../../components/function/Switch";
import CountUp from "react-countup";
import Footer from "../../components/modules/Footer";
import { useTranslation } from "react-i18next";

const Tarif = () => {
  const { t } = useTranslation("common");

  const [isChoosen, setIsChoosen] = useState(45);
  const [optionEquitation, setOptionEquitation] = useState(0);
  const [optionGourde, setOptionGourde] = useState(0);
  const [optionEcocup] = useState(0);
  const [optionTeeshirt, setOptionTeeshirt] = useState(0);
  const [optionSweat, setOptionSweat] = useState(0);
  const [optionCasquet, setOptionCasquet] = useState(0);
  const [optionBanane] = useState(0);

  const [isToogled, setisToggle] = useState(false);

  const minus = isToogled ? -10 : 0;

  const countCart =
    isChoosen +
    minus +
    15 * optionEquitation +
    20 * optionGourde +
    1 * optionEcocup +
    10 * optionTeeshirt +
    23 * optionSweat +
    10 * optionCasquet +
    9 * optionBanane;

  return (
    <div>
      <Navbar scroll="false" color="transparent" />
      <div className="cart">
        <AiOutlineShoppingCart className="shopping-cart" />
        <p>
          {" "}
          <CountUp
            start={0}
            end={countCart}
            duration={0.8}
            delay={0}
          ></CountUp>{" "}
          €
        </p>
      </div>
      <div className="switch-position">
        <SwitchButton
          isToogled={isToogled}
          onToggle={() => setisToggle(!isToogled)}
        />
      </div>

      <div className="tarif">
        <h1> {t("tarifs_de_participation.tarif_participation")}</h1>
        <div className="tarif-content">
          <div className="tarif-container-card">
            <h3> Tarif pour les {isToogled ? "fanfares" : "sportifs"}</h3>
            <div className="tarif-content-card">
              <div
                className={
                  isChoosen === 45
                    ? "tarif-content-1 choosen-card"
                    : "tarif-content-1"
                }
              >
                <h4> {isToogled ? "35" : "45"} €</h4>
                <h2> {t("tarifs_de_participation.Basique")} </h2>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.incription_tournoi")}</p>
                  </li>
                  <li>
                    {" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_activites")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_soiree")}</p>
                  </li>
                </ul>
                <button onClick={() => setIsChoosen(45)}> Choisir </button>
              </div>
              <div
                className={
                  isChoosen === 54
                    ? "tarif-content-1 choosen-card"
                    : "tarif-content-1"
                }
              >
                <h4> {isToogled ? "44" : "54"} €</h4>
                <h2> {t("tarifs_de_participation.Dejeuners_seulement")}</h2>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.incription_tournoi")}</p>
                  </li>
                  <li>
                    {" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_activites")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_soiree")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.dejeuner")}</p>
                  </li>
                </ul>
                <button onClick={() => setIsChoosen(54)}> Choisir </button>
              </div>
              <div
                className={
                  isChoosen === 62
                    ? "tarif-content-1 choosen-card"
                    : "tarif-content-1"
                }
              >
                <h4> {isToogled ? "52" : "62"} €</h4>
                <h2> {t("tarifs_de_participation.Restauration_complete")}</h2>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.incription_tournoi")}</p>
                  </li>
                  <li>
                    {" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_activites")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_soiree")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.dejeuner diner")}</p>
                  </li>
                </ul>
                <button onClick={() => setIsChoosen(62)}> Choisir </button>
              </div>
              <div
                className={
                  isChoosen === 73
                    ? "tarif-content-1 choosen-card"
                    : "tarif-content-1"
                }
              >
                <h4> {isToogled ? "63" : "73"} €</h4>
                <h2>
                  {" "}
                  {t("tarifs_de_participation.Hebergement")}<br></br> {t("tarifs_de_participation.en_tente")}
                </h2>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.incription_tournoi")}</p>
                  </li>
                  <li>
                    {" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_activites")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_soiree")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.dejeuner diner ptdej")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.Hebergement")}</p>
                  </li>
                </ul>
                <button onClick={() => setIsChoosen(73)}> Choisir </button>
              </div>
              <div
                className={
                  isChoosen === 63
                    ? "tarif-content-1 choosen-card"
                    : "tarif-content-1"
                }
              >
                <h4> {isToogled ? "53" : "63"} €</h4>
                <h2>
                  {" "}
                  {t("tarifs_de_participation.Hebergement")} <br /> {t("tarifs_de_participation.en_residence")}
                </h2>

                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.incription_tournoi")}</p>
                  </li>
                  <li>
                    {" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_activites")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_soiree")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.dejeuner diner ptdej")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.hebergement_residence")}</p>
                  </li>
                </ul>
                <button onClick={() => setIsChoosen(63)}>
                  {" "}
                  {t("tarifs_de_participation.choisir")}{" "}
                </button>
              </div>

              <div
                className={
                  isChoosen === 55
                    ? "tarif-content-1 choosen-card"
                    : "tarif-content-1"
                }
              >
                <h4> {isToogled ? "45" : "55"} €</h4>
                <h2>
                  {" "}
                  {t("tarifs_de_participation.Hebergement")} <br /> {t("tarifs_de_participation.en_residence_sans_diner")}
                </h2>
                <ul>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.incription_tournoi")}</p>
                  </li>
                  <li>
                    {" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_activites")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.acces_soiree")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.dejeuner pt")}</p>
                  </li>
                  <li>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                        fill="#5243C2"
                        fillOpacity="0.15"
                        className="svg1"
                      />
                      <path
                        d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                        fill="#BB6BD9"
                        className="svg2"
                      />
                    </svg>
                    <p>{t("tarifs_de_participation.hebergement_residence")}</p>
                  </li>
                </ul>
                <button onClick={() => setIsChoosen(55)}>
                  {" "}
                  {t("tarifs_de_participation.choisir")}{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tarif-options">
        <h2> Options</h2>
        <div className="tarif-options-container">
          <div className="tarif-options-card">
            <div className="tarif-options-button">
              <button onClick={() => setOptionEquitation(!optionEquitation)}>
                {" "}
                {t("tarifs_de_participation.supplement_equitation")}
              </button>
              <div className={optionEquitation ? "actives" : "desactives"}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                    fill="#5243C2"
                    fillOpacity="0.15"
                    className="svg4"
                  />
                  <path
                    d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                    fill="#BB6BD9"
                    className="svg3"
                  />
                </svg>
              </div>
              <h5> 15 €</h5>
            </div>
            <div className="tarif-options-button">
              <button onClick={() => setOptionGourde(!optionGourde)}>
                {" "}
                {t("tarifs_de_participation.gourde")}
              </button>
              <div className={optionGourde ? "actives" : "desactives"}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                    fill="#5243C2"
                    fillOpacity="0.15"
                    className="svg4"
                  />
                  <path
                    d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                    fill="#BB6BD9"
                    className="svg3"
                  />
                </svg>
              </div>
              <h5> 20 €</h5>
            </div>
            

          
            <div className="tarif-options-button">
              <button onClick={() => setOptionSweat(!optionSweat)}>
                {" "}
                Sweat TOSS
              </button>
              <div className={optionSweat ? "actives" : "desactives"}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                    fill="#5243C2"
                    fillOpacity="0.15"
                    className="svg4"
                  />
                  <path
                    d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                    fill="#BB6BD9"
                    className="svg3"
                  />
                </svg>
              </div>
              <h5> 23 €</h5>
            </div>
            <div className="tarif-options-button">
              <button onClick={() => setOptionTeeshirt(!optionTeeshirt)}>
                {" "}
                Tee Shirt TOSS
              </button>
              <div className={optionTeeshirt ? "actives" : "desactives"}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                    fill="#5243C2"
                    fillOpacity="0.15"
                    className="svg4"
                  />
                  <path
                    d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                    fill="#BB6BD9"
                    className="svg3"
                  />
                </svg>
              </div>
              <h5> 10 €</h5>
            </div>
            <div className="tarif-options-button">
              <button onClick={() => setOptionCasquet(!optionCasquet)}>
                {" "}
                {t("tarifs_de_participation.casquette")}
              </button>
              <div className={optionCasquet ? "actives" : "desactives"}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z"
                    fill="#5243C2"
                    fillOpacity="0.15"
                    className="svg4"
                  />
                  <path
                    d="M15.7725 6.83334L10.0683 14.5742C9.93228 14.7547 9.72942 14.8729 9.50533 14.9024C9.28124 14.9319 9.05472 14.87 8.87665 14.7308L4.80331 11.4742C4.44387 11.1865 4.38567 10.662 4.67331 10.3025C4.96096 9.94306 5.48554 9.88486 5.84498 10.1725L9.24165 12.89L14.4308 5.84751C14.601 5.59217 14.8977 5.45099 15.2032 5.48004C15.5086 5.50909 15.7734 5.70365 15.8924 5.98649C16.0114 6.26932 15.9653 6.59466 15.7725 6.83334Z"
                    fill="#BB6BD9"
                    className="svg3"
                  />
                </svg>
              </div>
              <h5> 10 €</h5>
            </div>
          </div>
        </div>
        <div className="register">
          <a href="https://toss-register.bds-cs.fr/register">
            {t("tarifs_de_participation.s_inscrire")}
          </a>
        </div>
      </div>
      <Footer color="rgba(35, 29, 79, 1)" />
    </div>
  );
};

export default Tarif;
